var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineasManoDeObra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1190",
    "data-name": "Group 1190",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.057,
    height: 49.628,
    viewBox: "0 0 53.057 49.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M21.735,18A6.281,6.281,0,0,1,17.291,7.279L23.849.719A1.118,1.118,0,0,1,25.43,2.3l-6.558,6.56A4.049,4.049,0,0,0,24.6,14.587l6.558-6.558A1.118,1.118,0,1,1,32.738,9.61L26.18,16.168A6.265,6.265,0,0,1,21.735,18",
    transform: "translate(19.114 0.485)",
    fill: "#075577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M25.2,28.069A14.037,14.037,0,0,1,15.28,4.109,14.117,14.117,0,0,1,30.338.951a1.118,1.118,0,1,1-.8,2.087A11.812,11.812,0,0,0,16.861,22.377a11.8,11.8,0,0,0,16.686,0A11.879,11.879,0,0,0,36.2,9.705a1.118,1.118,0,1,1,2.087-.8,14.109,14.109,0,0,1-3.158,15.056A13.937,13.937,0,0,1,25.2,28.069",
    transform: "translate(13.817 0)",
    fill: "#075577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M7.853,39.791a6.285,6.285,0,0,1-4.444-10.73L24.253,8.219A1.118,1.118,0,1,1,25.835,9.8L4.99,30.642a4.049,4.049,0,0,0,5.726,5.726L31.559,15.524a1.118,1.118,0,1,1,1.581,1.581L12.3,37.95a6.241,6.241,0,0,1-4.444,1.841",
    transform: "translate(1.94 9.758)",
    fill: "#075577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M6.1,20.233a1.118,1.118,0,1,1-1.118-1.118A1.119,1.119,0,0,1,6.1,20.233",
    transform: "translate(4.776 23.641)",
    fill: "#075577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M20.1,20.233a1.118,1.118,0,1,1-1.118-1.118A1.119,1.119,0,0,1,20.1,20.233",
    transform: "translate(22.091 23.641)",
    fill: "#075577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M10.252,15.936a1.136,1.136,0,0,1-.353-.058l-5.48-1.827a1.128,1.128,0,0,1-.646-.561L.117,6.182a1.12,1.12,0,0,1,.21-1.291L3.982,1.236a1.119,1.119,0,0,1,1.291-.208L12.58,4.681a1.116,1.116,0,0,1,.559.646l1.827,5.482a1.119,1.119,0,0,1-.268,1.143l-3.655,3.655a1.112,1.112,0,0,1-.792.329M5.566,12.074,9.95,13.536l2.677-2.675L11.164,6.475,4.993,3.388,2.479,5.9Z",
    transform: "translate(0.001 1.126)",
    fill: "#075577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M27.821,35.015a6.238,6.238,0,0,1-4.442-1.843L11.235,21.029a1.118,1.118,0,0,1,1.581-1.581L24.96,31.591a4.136,4.136,0,0,0,5.722,0,4.054,4.054,0,0,0,0-5.724L18.54,13.723a1.118,1.118,0,0,1,1.581-1.581L32.263,24.285a6.286,6.286,0,0,1-4.442,10.73",
    transform: "translate(13.492 14.612)",
    fill: "#075577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M14.971,20.661a1.123,1.123,0,0,1-.792-.327L4.411,10.562a1.115,1.115,0,0,1,0-1.581L8.072,5.319a1.118,1.118,0,0,1,1.584,0l9.77,9.793a1.119,1.119,0,0,1-1.584,1.581l-8.978-9L6.782,9.772l8.981,8.978a1.118,1.118,0,0,1-.792,1.91",
    transform: "translate(5.05 6.172)",
    fill: "#075577"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineasManoDeObra);
export default __webpack_public_path__ + "static/media/lineasManoDeObra.49dc3b1d673c04d051f5470d2e0b9f90.svg";
export { ForwardRef as ReactComponent };